import { Chip, Typography, UserMessageIcon } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';
import { Props } from '../AdvancedLeaderProgram';

function Coaching({ children }: Props) {
  return (
    <div className="mb-2 flex">
      <Chip variant="outlined" color="purple" radius="full" className="mr-2">
        <span className="mr-2">
          <UserMessageIcon color="purple" />
        </span>
        <span>
          <Typography color="purple" variant="caption">
            <T kind="Coaching" />
          </Typography>
        </span>
        {children}
      </Chip>
    </div>
  );
}

export default observer(Coaching);
